module.exports = __webpack_public_path__ + "img/bear4.890b3942.png";